import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isBefore, startOfDay } from 'date-fns';
import { InvoiceDisplayStatusV2, PaymentDetailType } from 'anchor-scout-common/types';
import { InvoiceAccountingIntegration } from '../InvoiceAccountingIntegration';
import { InvoiceIntegrationModel, InvoiceIntegrationStatus } from '../InvoiceIntegrationModel';
import { filterPaymentDetailsForClient } from './translator';
export function setVoided(invoice) {
    return _object_spread_props(_object_spread({}, invoice), {
        displayStatusV2: InvoiceDisplayStatusV2.Voided,
        paymentDetails: [
            {
                type: PaymentDetailType.Voided,
                date: '0'
            }
        ]
    });
}
export function setRefundRequested(invoice) {
    return _object_spread_props(_object_spread({}, invoice), {
        paymentDetails: [
            {
                type: PaymentDetailType.RefundRequested
            },
            ...invoice.paymentDetails
        ]
    });
}
export function setPartialRefundRequested(invoice) {
    return _object_spread_props(_object_spread({}, invoice), {
        paymentDetails: [
            {
                type: PaymentDetailType.RefundRequested
            },
            ...invoice.paymentDetails
        ]
    });
}
export function setRefunded(invoice, timestamp, now) {
    const recordedIntegration = new InvoiceIntegrationModel({
        status: InvoiceIntegrationStatus.RefundRecorded,
        date: now.getTime()
    });
    return _object_spread_props(_object_spread({}, invoice), {
        displayStatusV2: InvoiceDisplayStatusV2.Refunded,
        paymentDetails: [
            {
                type: PaymentDetailType.Refunded,
                date: String(timestamp)
            }
        ],
        integration: recordedIntegration,
        xeroIntegration: new InvoiceAccountingIntegration(recordedIntegration, invoice.xeroIntegration.isSynced())
    });
}
export function setPartiallyRefunded(invoice, timestamp) {
    return _object_spread_props(_object_spread({}, invoice), {
        displayStatusV2: InvoiceDisplayStatusV2.PartiallyRefunded,
        paymentDetails: [
            {
                type: PaymentDetailType.Refunded,
                date: String(timestamp)
            }
        ]
    });
}
export function setPending(invoice, now) {
    return _object_spread_props(_object_spread({}, invoice), {
        displayStatusV2: isBefore(startOfDay(invoice.rawDueDate), startOfDay(now)) ? InvoiceDisplayStatusV2.Overdue : InvoiceDisplayStatusV2.Issued,
        paymentDetails: []
    });
}
export function setPaymentConfirmed(invoice, isVendor) {
    const backendPaymentDetails = [
        {
            type: PaymentDetailType.PaymentCollected
        }
    ];
    return _object_spread_props(_object_spread({}, invoice), {
        displayStatusV2: InvoiceDisplayStatusV2.Processing,
        paymentDetails: isVendor ? backendPaymentDetails : filterPaymentDetailsForClient(backendPaymentDetails)
    });
}
export function setIntegration(invoice, integration) {
    return _object_spread_props(_object_spread({}, invoice), {
        integration
    });
}
export function setXeroIntegration(invoice, integration) {
    return _object_spread_props(_object_spread({}, invoice), {
        xeroIntegration: new InvoiceAccountingIntegration(integration, invoice.xeroIntegration.isSynced())
    });
}
